<div class="field-holder w2" [formGroup]="frmUtilityRateCode">
  <mat-form-field>
    <mat-label>Load Profile</mat-label>
    <mat-select id="utilityRateCode" formControlName="utilityRateCode">
      <mat-option value="">-- Please Select --</mat-option>
      <mat-option *ngFor="let utilityRateCode of utilityRateCodes" [value]="utilityRateCode">{{ utilityRateCode.rateCode }}</mat-option>
    </mat-select>
    <mat-error> Please select a Load Profile </mat-error>
    <mat-spinner
      matSuffix
      [diameter]="16"
      *ngIf="this.utilityRateCodes?.length <= 1 && this.frmUtilityRateCode.get('utilityRateCode').enabled"
      color="primary"
      [matTooltip]="'Fetching available utilities.'"
    ></mat-spinner>
  </mat-form-field>
</div>
